
namespace TabAurous.Common {

    import fld = Stock.StockItemRow.Fields;
    @Serenity.Decorators.registerClass()
    export class StockStoneSelectGrid extends _Ext.GridBase<Stock.StockItemRow, any> {
     
        protected getColumnsKey() { return 'Stock.StockItem'; } 
        protected getIdProperty() { return Stock.StockItemRow.idProperty; }
        protected getInsertPermission() { return Stock.StockItemRow.insertPermission; }
        protected getLocalTextPrefix() { return Stock.StockItemRow.localTextPrefix; }
        protected getService() { return Stock.StoneStockService.baseUrl; }
        
        private autoSize;
        private pendingChanges: Q.Dictionary<any> = {}; 
 
        //withBom: boolean;
        constructor(container: JQuery,options) {
            super(container, options);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            (this.view.params as ProductRequest).LotNo = options.GridFilters.LotNo;
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        get selectedItems(): Stock.StockItemRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }
        

        protected onViewSubmit() {
            if (!super.onViewSubmit.call(this))
                return false; 
            return true;

        }
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        
        protected getViewOptions() {
            var opt = super.getViewOptions();
            
            opt.rowsPerPage = 100;
            return opt;
        }
        

    }
}